import {
  FromBackendNetworkLineDirection,
  getMultipleLineDirections,
} from './network.api'
import { FromBackendStopTrip } from './travelinfo-trip.api'

export type EnrichedFromBackendStopTrip = FromBackendStopTrip & {
  lineDirection: FromBackendNetworkLineDirection
}

export function getAllLineDirectionIdsFromTrips(
  trips: FromBackendStopTrip[],
): string[] {
  const lineDirectionIdSet = new Set<string>()
  trips.forEach((trip) => {
    lineDirectionIdSet.add(trip.lineDirection.id)
  })
  return Array.from(lineDirectionIdSet).filter(Boolean)
}

export function groupBy(
  arr: FromBackendNetworkLineDirection[],
  prop: keyof FromBackendNetworkLineDirection,
) {
  const initialReduceValue: Record<string, FromBackendNetworkLineDirection> = {}
  return arr.reduce((result, obj) => {
    const key = obj[prop].toString()
    result[key] = obj
    return result
  }, initialReduceValue)
}

export async function enrichTripsLineDirections(
  trips: FromBackendStopTrip[],
): Promise<EnrichedFromBackendStopTrip[]> {
  const lineDirectionIds = getAllLineDirectionIdsFromTrips(trips)

  const enrichedLineDirections =
    await getMultipleLineDirections(lineDirectionIds)

  const enrichedLineDirectionsById: Record<
    string,
    FromBackendNetworkLineDirection
  > = groupBy(enrichedLineDirections, 'id')

  return trips
    .map((trip) => ({
      ...trip,
      lineDirection: {
        ...enrichedLineDirectionsById[trip.lineDirection.id],
        line: trip.lineDirection.line,
      },
    }))
    .filter((trip) => trip.lineDirection !== undefined)
}
